<template>
  <v-navigation-drawer v-model="isSidebarActiveLocal" fixed temporary width="300" right>
    <v-card>
      <v-card-title class="justify-center">
        Filtro
      </v-card-title>
      <v-card-text>
        <v-card-actions>
          <v-row  align="center" justify="center">
            <v-row>
<!--            tipo  documento-->
          <v-col class="12">
            <v-row  justify="center" align="center">
              <v-col cols="2" >
                <v-row justify="center">
                <span>Tipo</span>
                </v-row>
                </v-col>
              <v-col cols="9">
                <v-row justify="center">
                <v-select
                  dense
                  :disabled="diableTypeItem"
                  hide-details
                  outlined
                  color="green"
                  item-value="text"
                  item-text="title"
                  :items="itemsType"
                  label="Documentos"
                ></v-select>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
            </v-row>

<!--            <v-row>-->
<!--&lt;!&ndash;            tipo  status&ndash;&gt;-->
<!--              <v-col class="12">-->
<!--                <v-row  justify="center" align="center">-->
<!--                  <v-col cols="2" >-->
<!--                    <v-row justify="center">-->
<!--                      <span>Status</span>-->
<!--                    </v-row>-->
<!--                  </v-col>-->
<!--                  <v-col cols="9">-->
<!--                    <v-row justify="center">-->
<!--                      <v-select-->
<!--                        dense-->
<!--                        hide-details-->
<!--                        outlined-->
<!--                        color="green"-->
<!--                        item-value="title"-->
<!--                        item-text="title"-->
<!--                        :items="items"-->
<!--                        label="Status"-->
<!--                      ></v-select>-->
<!--                    </v-row>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--              </v-col>-->
<!--            </v-row>-->

            <v-row>
              <!--            tipo  local-->
              <v-col class="12">
                <v-row  justify="center" align="center">
                  <v-col cols="2" >
                    <v-row justify="center">
                      <span>Local</span>
                    </v-row>
                  </v-col>
                  <v-col cols="9">
                    <v-row justify="center">
                      <v-select
                        dense
                        hide-details
                        outlined
                        color="green"
                        return-object
                        item-text="name"
                        :items="itemsBox"
                        label="Inbox"
                        @change="selectLocalBox"
                      ></v-select>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row align="start" >
              <v-col  cols="12">
                <v-row  class="ml-2">
                Pasta:
                </v-row>
              </v-col>
              <!--                    check pessoal-->
              <v-col  cols="6">
                <v-row  align="start" justify="center">
                    <v-checkbox
                      open-on-clear
                      dense
                      v-model="checkPerson"
                      label="Pessoal"
                    >
                    </v-checkbox>
                </v-row>
              </v-col>
              <!--                fim check pessoal-->
              <!--                    check setor-->
<!--              <v-col   cols="6">-->
<!--                <v-row  align="start" justify="center">-->
<!--                    <v-checkbox-->
<!--                      open-on-clear-->
<!--                      dense-->
<!--                      label="Setor"-->
<!--                    >-->

<!--                    </v-checkbox>-->
<!--                </v-row>-->
<!--              </v-col>-->
              <!--                    fim chek setor-->
<!--            </v-row>-->

<!--            <v-col cols="12">-->
<!--              <v-row align="center" justify="end">-->
<!--                <v-col  cols="12">-->
<!--                  <v-btn  color="primary" block >Filtrar</v-btn>-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--            </v-col>-->
          </v-row>
          </v-row>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>

</template>

<script>

 export default {
  name: "FormFilterDrawer",
  methods:{
   clear() {
    this.isSidebarActiveLocal = false;
   },
   getIndex(item){
    this.selectdocument = item.title
   },
   selectLocalBox(item){
      this.$emit('selectLocalBox',item)
      this.clear()
   }
  },
  data: () => ({
   addNewDataSidebar: false,
   singleSelect: false,
   selected: [],
   items: [
    { title: 'Todos' },
    { title: 'Nenhum' },
    { title: 'Lidas' },
    { title: 'Não Lidas' },
    { title: 'Sem Etiquetas' },
    { title: 'Com Etiquetas' },
   ],
   diableTypeItem:true,
   itemsType:[
     {title: 'Memorando'},
     {title: 'Ofício'},
     ],
   selectdocument:'Memorando',
   headers: [
    { text: "Numero", align: "left", value: "name" },
    { text: "De", align: "left", value: "email" },
    { text: "Para", align: "left", value: "shortname" },
    { text: "Assunto", align: "left", value: "phone" },
    { text: "Etiqueta", value: "actions"  },
    { text: "Tempo", value: "actions"},
    { text: "Ação", value: "actions", sortable: false },
   ],
  }),
  props:{
   isSidebarActive: {
    type: Boolean,
    required: true,
   },
   folks:{
    type:Boolean
   }
  },
  computed: {
   isSidebarActiveLocal: {
    get() {
     return this.isSidebarActive;
    },
    set(val) {
     if (!val) {
      this.$emit("closeSidebar");
     }
    },
   },
   checkPerson: {
    get() {
     return this.folks
    },
    set(val) {
     this.$emit('checkperson', val)
    }
   },
  },
  apollo: {
   itemsBox: {
    query: require("@/graphql/queries/Documents.gql").getFolders,
    update: (data) => data.folders,
   },
  },
 }
</script>

<style scoped>
</style>